import { inject } from '@angular/core';
import { SchemaFormsService } from '@apexdesigner/schema-forms';

export function registerSchemaFormFields(): void {
  const schemaForms = inject(SchemaFormsService);

  // Field registrations (library order — later overrides earlier)
  schemaForms.registerField('select-role', () =>
    import('@components/select-role-field/select-role-field.component').then(
      (m) => m.SelectRoleFieldComponent,
    ),
  );
  schemaForms.registerField('select-role-name', () =>
    import('@components/select-role-name-field/select-role-name-field.component').then(
      (m) => m.SelectRoleNameFieldComponent,
    ),
  );
  schemaForms.registerField('select-user', () =>
    import('@components/select-user-field/select-user-field.component').then(
      (m) => m.SelectUserFieldComponent,
    ),
  );
  schemaForms.registerField('currency', () =>
    import('@components/sf-currency-field/sf-currency-field.component').then(
      (m) => m.SfCurrencyFieldComponent,
    ),
  );
  schemaForms.registerField('decimal', () =>
    import('@components/sf-decimal-field/sf-decimal-field.component').then(
      (m) => m.SfDecimalFieldComponent,
    ),
  );
  schemaForms.registerField('integer', () =>
    import('@components/sf-integer-field/sf-integer-field.component').then(
      (m) => m.SfIntegerFieldComponent,
    ),
  );
  schemaForms.registerField('percentage', () =>
    import('@components/sf-percentage-field/sf-percentage-field.component').then(
      (m) => m.SfPercentageFieldComponent,
    ),
  );
  schemaForms.registerField('reference', () =>
    import('@components/sf-reference-field/sf-reference-field.component').then(
      (m) => m.SfReferenceFieldComponent,
    ),
  );
  schemaForms.registerField('timezone', () =>
    import('@components/sf-timezone-field/sf-timezone-field.component').then(
      (m) => m.SfTimezoneFieldComponent,
    ),
  );
  schemaForms.registerField('select-called-process', () =>
    import('@components/select-called-process-field/select-called-process-field.component').then(
      (m) => m.SelectCalledProcessFieldComponent,
    ),
  );
  schemaForms.registerField('select-process-message', () =>
    import('@components/select-process-message-field/select-process-message-field.component').then(
      (m) => m.SelectProcessMessageFieldComponent,
    ),
  );
  schemaForms.registerField('select-process-role', () =>
    import('@components/select-process-role-field/select-process-role-field.component').then(
      (m) => m.SelectProcessRoleFieldComponent,
    ),
  );
  schemaForms.registerField('select-process-service', () =>
    import('@components/select-process-service-field/select-process-service-field.component').then(
      (m) => m.SelectProcessServiceFieldComponent,
    ),
  );
  schemaForms.registerField('select-process-user-interface', () =>
    import('@components/select-process-user-interface-field/select-process-user-interface-field.component').then(
      (m) => m.SelectProcessUserInterfaceFieldComponent,
    ),
  );
  schemaForms.registerField('select-service-queue', () =>
    import('@components/select-service-queue-field/select-service-queue-field.component').then(
      (m) => m.SelectServiceQueueFieldComponent,
    ),
  );
  schemaForms.registerField('select-user-interface-component', () =>
    import('@components/select-user-interface-component/select-user-interface-component.component').then(
      (m) => m.SelectUserInterfaceComponentComponent,
    ),
  );

  // Section registrations (library order — later overrides earlier)
  schemaForms.registerSection('sf-process-data-property-section', () =>
    import('@components/process-data-property-section/process-data-property-section.component').then(
      (m) => m.ProcessDataPropertySectionComponent as any,
    ),
  );
  schemaForms.registerSection('sf-process-data-value-section', () =>
    import('@components/process-data-value-section/process-data-value-section.component').then(
      (m) => m.ProcessDataValueSectionComponent as any,
    ),
  );
  schemaForms.registerSection('sf-process-function-parameter-section', () =>
    import('@components/process-function-parameter-section/process-function-parameter-section.component').then(
      (m) => m.ProcessFunctionParameterSectionComponent as any,
    ),
  );
  schemaForms.registerSection('sf-process-message-property-section', () =>
    import('@components/process-message-property-section/process-message-property-section.component').then(
      (m) => m.ProcessMessagePropertySectionComponent as any,
    ),
  );
  schemaForms.registerSection('sf-process-service-property-section', () =>
    import('@components/process-service-property-section/process-service-property-section.component').then(
      (m) => m.ProcessServicePropertySectionComponent as any,
    ),
  );
  schemaForms.registerSection(
    'sf-process-user-interface-property-section',
    () =>
      import('@components/process-user-interface-property-section/process-user-interface-property-section.component').then(
        (m) => m.ProcessUserInterfacePropertySectionComponent as any,
      ),
  );
}
